import type { CharacterCommission, Commission } from './commission';

/**
 * The Journal: a character's story so far, oldest first, as returned by
 * `GET /api/accounts/:id/characters/:characterId/journal`. It mixes the
 * cutscenes the character has watched (which can be replayed) with the
 * commissions they've held, each of which plans a Crucible run.
 */

/** A cutscene the character has watched. */
export interface JournalCutscene {
    cutsceneId: string;
    title: string;
    /** The cutscene's spoiler-free `summary`. */
    summary: string;
    /** When it was first watched (or skipped). */
    seenAt: string;
    /** URL path of the cutscene's Journal sketch, when it has one. */
    sketchUrl?: string;
}

/** One entry in the Journal. */
export type JournalEntry =
    | { kind: 'cutscene'; id: string; at: string; cutscene: JournalCutscene }
    | {
        kind: 'commission';
        id: string;
        at: string;
        commission: CharacterCommission;
        content: Commission;
        /** The vision the commission's run surfaced to the character, when it did. */
        vision?: { visionId: string; title: string };
    };

/** A watched cutscene's journal entry id, which the server lists it by and the Journey tab selects it by. */
export function toCutsceneJournalEntryId(cutsceneId: string): string {
    return `cutscene:${cutsceneId}`;
}
